import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  imports:[MatCardModule,MatButtonModule,MatIconModule,MatIconModule],
  standalone:true
})
export class ErrorPageComponent {
  @Input("error") errorMessage: string = 'The booking page may have been deleted or the link may be incorrect.';
  @Input("title") title: string = 'Booking page not found';

  constructor(private route: ActivatedRoute, private router: Router) {
    // Get error message from route parameters
    this.route.queryParams.subscribe(params => {
      if (params['message']) {
        this.errorMessage = params['message'];
      }
    });
  }

  goHome() {
    this.router.navigate(['/']); // Redirect to home page
  }
}
